// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "bridge" + "." + "4ef57a16" + ".chunk.css";
};